import type { BundleTaskCreationResultDto, CreateMultiSelectTicketDto, CreateTicketDto, GetTicketListDto, GetTikcetListByDatesDto, TenantDashboardTicketDto, TicketDto, TicketExcelDownloadDto, UpdateTicketDto } from './models';
import { RestService } from '@abp/ng.core';
import type { ListResultDto, PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { TenantUserLookupDto } from '../enova-users-lookup/models';
import type { DownloadTokenResultDto, LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class TicketsService {
  apiName = 'Default';
  

  create = (input: CreateTicketDto) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/tickets',
      body: input,
    },
    { apiName: this.apiName });
  

  createBundleTasks = (input: CreateTicketDto) =>
    this.restService.request<any, BundleTaskCreationResultDto>({
      method: 'POST',
      url: '/api/app/tickets/bundle-tasks',
      body: input,
    },
    { apiName: this.apiName });
  

  createMultiSelectTasks = (input: CreateMultiSelectTicketDto) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/tickets/multi-select-tasks',
      body: input,
    },
    { apiName: this.apiName });
  

  createTicketForDocumentApprovalByTenantDocumentId = (tenantDocumentId: string) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/tickets/ticket-for-document-approval/${tenantDocumentId}`,
    },
    { apiName: this.apiName });
  

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/tickets/${id}`,
    },
    { apiName: this.apiName });
  

  get = (id: string) =>
    this.restService.request<any, TicketDto>({
      method: 'GET',
      url: `/api/app/tickets/${id}`,
    },
    { apiName: this.apiName });
  

  getDownloadToken = () =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/app/tickets/download-token',
    },
    { apiName: this.apiName });
  

  getFilteredList = (input: GetTikcetListByDatesDto) =>
    this.restService.request<any, TenantDashboardTicketDto>({
      method: 'GET',
      url: '/api/app/tickets/filtered-list',
      params: { fromDate: input.fromDate, toDate: input.toDate },
    },
    { apiName: this.apiName });
  

  getList = (input: GetTicketListDto) =>
    this.restService.request<any, PagedResultDto<TicketDto>>({
      method: 'GET',
      url: '/api/app/tickets',
      params: { filter: input.filter, status: input.status, assignedUserId: input.assignedUserId, startDate: input.startDate, endDate: input.endDate, tenantDocumentId: input.tenantDocumentId, tenantCourseId: input.tenantCourseId, ticketKind: input.ticketKind, ticketEducationKind: input.ticketEducationKind, organizationUnitsIds: input.organizationUnitsIds, active: input.active, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  getListAsExcelFile = (input: TicketExcelDownloadDto) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/app/tickets/as-excel-file',
      params: { downloadToken: input.downloadToken, filter: input.filter, taskStatus: input.taskStatus, assignedUserId: input.assignedUserId, taskKind: input.taskKind, taskEducationKind: input.taskEducationKind, tenantDocumentId: input.tenantDocumentId, tenantCourseId: input.tenantCourseId, startDate: input.startDate, endDate: input.endDate, organizationUnitId: input.organizationUnitId, active: input.active },
    },
    { apiName: this.apiName });
  

  getTenantUserLookup = (active?: boolean) =>
    this.restService.request<any, ListResultDto<TenantUserLookupDto>>({
      method: 'GET',
      url: '/api/app/tickets/tenant-user-lookup',
      params: { active },
    },
    { apiName: this.apiName });
  

  getTestLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/app/tickets/test-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  update = (id: string, input: UpdateTicketDto) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: `/api/app/tickets/${id}`,
      body: input,
    },
    { apiName: this.apiName });
  

  updateTicketStatusByTicketId = (ticketId: string) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: `/api/app/tickets/ticket-status/${ticketId}`,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
